import { createContext, useContext } from 'react'

import { type CrossClientQueryResult } from '../../../models/CrossClient'

import { type CrmActionKind } from './crmActionRegistry'
import { type CrossClientActionScope } from './useActionTracking'

export interface CrmActionHostOpenArgs {
  resolveResults: () => Promise<CrossClientQueryResult[]>
  scope: CrossClientActionScope
}

export interface CrmActionHostContextValue {
  open: (kind: CrmActionKind, args: CrmActionHostOpenArgs) => void
  close: () => void
}

export const CrmActionHostContext = createContext<CrmActionHostContextValue | null>(null)

export const useCrmActionHost = (): CrmActionHostContextValue => {
  const ctx = useContext(CrmActionHostContext)
  if (!ctx) {
    throw new Error('useCrmActionHost must be used within a CrmActionHostProvider')
  }
  return ctx
}
